import { cn } from "~/lib/utils"

type Tone = "dark" | "light"

// On dark grounds (forest footer/bands) the black "pine" would vanish, so we
// flip the whole mark to white. On light grounds we render the SVG as-authored
// (pine in black, "59°" in chartreuse).
const toneClass = (tone: Tone) =>
  tone === "light" ? "[filter:brightness(0)_invert(1)]" : ""

// Compact mark: pine triangle + "59°" (public/brand/logo-symbol.svg).
export function PineMark({
  className,
  tone = "dark",
}: {
  className?: string
  tone?: Tone
}) {
  return (
    <img
      src="/brand/logo-symbol.svg"
      alt="Pine59"
      className={cn("h-8 w-auto", toneClass(tone), className)}
    />
  )
}

// Full lockup: "pine59°" wordmark (public/brand/logo-full.svg).
export function Wordmark({
  className,
  tone = "dark",
}: {
  className?: string
  tone?: Tone
}) {
  return (
    <span className={cn("inline-flex items-center", className)}>
      <img
        src="/brand/logo-full.svg"
        alt="Pine59"
        className={cn("h-7 w-auto", toneClass(tone))}
      />
    </span>
  )
}
